import { PoolWidgetColor } from "./interfaces/DineCashPooling";

export const GOT_IT = "Got it";

export const EMPTY_STATE_BUTTON_TEXT = "Browse events";

export const EMPTY_STATE_MAIN_TEXT = "What's the Scene?";

export const EMPTY_STATE_SUB_TEXT = "Your ticket cart is empty :(";

export const EMPTY_STATE_SUB_TEXT_SECOND = "Find cool events to match your vibe";

export const EMPTY_STATE_IMAGE_URL = "seo%20web/illustration.png";

export const RUSH_HOUR_TEXT_BANNER = "dineout/rushhourtextbanner.png";

export const WIDGET_ICON_CLOUDINARY_ID = "portal/static-assets/images/Cart_Page_Icon.png";
export const WIDGET_ICON_ALT = "DineCash Pooling Icon";
export const WIDGET_ICON_WIDTH = "42px";
export const WIDGET_ICON_HEIGHT = "42px";

export const POOL_WIDGET_TYPE_COLOR_MAP: Record<string, PoolWidgetColor> = {
    WARN: "warning",
    INFO: "positive",
    ERROR: "negative",
};
